import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface StripeAmountContextType {
  amount: number | null;
  updateAmount: (newAmount: number) => void;
}

const StripeAmountContext = createContext<StripeAmountContextType | undefined>(undefined);

export const useStripeAmount = () => {
  const context = useContext(StripeAmountContext);
  if (!context) {
    throw new Error('useStripeAmount must be used within a StripeAmountProvider');
  }
  return context;
};

interface StripeAmountProviderProps {
  children: ReactNode;
  defaultAmount?: number;
}

export const StripeAmountProvider: React.FC<StripeAmountProviderProps> = ({ 
  children, 
  defaultAmount = null 
}) => {
  const [amount, setAmount] = useState<number | null>(defaultAmount);

  const updateAmount = useCallback((newAmount: number) => {
    setAmount(newAmount);
  }, []);

  return (
    <StripeAmountContext.Provider value={{ amount, updateAmount }}>
      {children}
    </StripeAmountContext.Provider>
  );
};